import { gql } from '@apollo/client';

export const notificationFragment = gql`
  fragment NotificationWithData on NotificationEvent {
    id
    type
    subject
    body
    created
    icon
    actions
    blogPostId
    phaseId
    challengeId
    commentId
    ideaId
    userId
    reasonType
    reasonId
    isValid
    idea {
      id
      title
      text
      stats {
        comments
        followers
        views
        votes
      }
      files {
        images {
          id
          hash
          extension
        }
      }
      user {
        id
        displayName
        userAccess {
          id
          userType
        }
      }
    }
    blogPost {
      id
      title
      text
      stats {
        comments
        followers
        views
      }
      files {
        images {
          id
          hash
          extension
        }
      }
    }
    challenge {
      id
      title
      description
      stats {
        comments
        ideas
        subscribers
        votes
      }
      files {
        list {
          id
          hash
          extension
        }
      }
    }
    user {
      id
      displayName
      profileImageFile {
        hash
        extension
        id
        name
        userId
      }
      userAccess {
        communityId
        id
        userId
        userType
        instanceJoined
      }
    }
  }
`;

export const GET_NOTIFICATIONS = gql`
  query notifications($categories: [NotificationCategory!]) {
    notifications(categories: $categories) {
      ...NotificationWithData
    }
  }
  ${notificationFragment}
`;
